/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod_Exp_LinkInputs */

const es_landing_mod_exp_link = /** @type {(inputs: Landing_Mod_Exp_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver experiencias`)
};

const gl_landing_mod_exp_link = /** @type {(inputs: Landing_Mod_Exp_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver experiencias`)
};

const en_landing_mod_exp_link = /** @type {(inputs: Landing_Mod_Exp_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse experiences`)
};

/**
* | output |
* | --- |
* | "Browse experiences" |
*
* @param {Landing_Mod_Exp_LinkInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod_exp_link = /** @type {((inputs?: Landing_Mod_Exp_LinkInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod_Exp_LinkInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod_exp_link(inputs)
	if (locale === "en") return en_landing_mod_exp_link(inputs)
	return es_landing_mod_exp_link(inputs)
});